angular.module('viewReferrals')
    .controller('ViewReferralsController', ['$scope', '$stateParams', 'FileUploader', 'Notification', 'Referral', 'PDF', 'Note', 'Attachment', '$uibModal', 'Logger', 'Auth',  'ModalHandler', 'FREE_TRIAL_PERIOD', 'API_ENDPOINT','message', 'ProgressIndicator', '$state', 'UploadService', 'CbctStripService', '$q', 'ReferralHelper', 'ConfirmDialog',
    function ($scope, $stateParams, FileUploader, Notification, Referral, PDF, Note, Attachment, $uibModal, Logger, Auth, ModalHandler, FREE_TRIAL_PERIOD, API_ENDPOINT, message, ProgressIndicator, $state, UploadService, CbctStripService, $q, ReferralHelper, ConfirmDialog) {
        // Initialize uploader immediately so directives can bind to it
        $scope.uploader = UploadService.createUploader({
            scope: $scope,
            url: API_ENDPOINT + '/attachment/upload',
            alias: 'attach',
            formData: [
                {filename: 'test'}
            ],
            immediateUpload: true,
            // Size-limit messages are generated by UploadService from the
            // MAX_ATTACHMENT_FILE_SIZE / MAX_REFERRAL_ATTACHMENTS_SIZE constants.
            onSuccessItem: function(item, response){
                if ($scope.referral && $scope.referral.attachments) {
                    $scope.referral.attachments.push(response); 
                }
            },
            onCompleteAll: function(){ 
                ProgressIndicator.finish(); 
                $scope.showOfferToInviteGuest(); 
            }
        });

        $scope.total_size = 0;

        $scope.auth = Auth.getOrRedirect();

        // CBCT scan strip (DCL-211): below the drop area, separate from the
        // attachments uploader. View-referral is always authenticated, so the
        // strip is enabled here. Unique input ids per host page.
        $scope.cbctFolderInputId = 'view-cbct-folder-input';
        $scope.cbctFileInputId = 'view-cbct-file-input';
        CbctStripService.attach($scope, {
            folderInputId: $scope.cbctFolderInputId,
            fileInputId: $scope.cbctFileInputId,
            // DCL-523: the referral's two practices are fixed here, so the server
            // answers the either-side question directly. Null until the referral
            // loads — the strip shows neither the button nor a wrong prompt while
            // the answer is unknown, and it never flips back to false, so nothing
            // is ever dropped on this page.
            eligibilityFn: function () {
                var referral = $scope.referral;
                if (!referral || referral.cbct_upload_allowed === undefined) { return null; }
                return !!referral.cbct_upload_allowed;
            }
        });
        // The referral already exists here, so "ensure draft" just resolves to it
        // (DCL-212 CBCT upload uses the same ensureDraftForUpload chain as
        // create-referral, where it lazily creates the draft instead).
        $scope.ensureDraftForUpload = function () {
            var id = $scope.referral && $scope.referral.id;
            return id ? $q.resolve(id) : $q.reject('referral.not.ready');
        };
        // Show/poll/delete need the referral id (DCL-214). Delete permission
        // rides on the scan JSON itself (`can_delete`, uploader's practice only).
        $scope.cbctReferralId = function () {
            return ($scope.referral && $scope.referral.id) || null;
        };

        $scope.initModel = function() {
            $scope.referral = Referral.get({id: $stateParams.referral_id},
                function (data) {
                    // DCL-539: beyond-allowance referrals arrive complete — the flag
                    // only controls the dismissible notice above the chart.
                    $scope.allowanceNoticeDismissed = !!(data.allowance && data.allowance.notice_dismissed);

                    angular.forEach(data.attachments, function(attachment, key){
                        $scope.total_size = $scope.total_size + attachment.attach_file_size;
                    });

                    data.teethChart = data.teeth.split('+');
                    if(data.dest_provider_id < 0){
                        data.dest_provider = {id: data.dest_provider_id, first_name: 'First', last_name: 'Available', firstAvailable: true}
                    } else if (!data.dest_provider) {
                        data.dest_provider = data.dest_provider_invited;
                    }
                    // DCL-214: render the persisted CBCT scan (metadata card +
                    // download + delete) and poll if it is still packaging. No-op
                    // when the referral has no scan or a card is already in flight
                    // (e.g. an in-session upload just finalized).
                    if (data.cbct_scan && $scope.cbct && $scope.cbct.state !== 'card' &&
                        $scope.cbct.state !== 'uploading') {
                        $scope.cbctInitFromScan(data.cbct_scan);
                    }
                },
                function (failure) {
                    if(failure.status === 422) {
                        $state.go('error_page', {error_key: failure.data.message});
                    }
                    Notification.error(failure.data.error)
                }
            );
            return $scope.referral.$promise;
        };

        $scope.initModel();

        if($stateParams.isNew){
            var modalInstance = $uibModal.open({
                templateUrl: 'partials/referral_create_message.html',
                controller: 'ReferralSuccessModalController',
                resolve: {
                    referral: function () {
                        return $scope.referral.$promise;
                    }
                }
            });
            ModalHandler.set(modalInstance);
            modalInstance.result.then(function() {
                var el = document.getElementById('downloadPdf');
                if (el) { el.scrollIntoView({ behavior: 'smooth' }); }
            }).catch(function () {
                // Logger.log('Modal dismissed');
            });
        }

        // DCL-477: the "Change Date" pencil. Offered to the practice that
        // uploaded the attachment, derived from the serialized author so it
        // still shows after a reload (it used to hang off a client-only
        // "recently added" flag set by the uploader).
        $scope.canEditAttachmentDate = function (attachment) {
            return ReferralHelper.canEditAttachmentDate($scope.auth, attachment);
        };

        $scope.openDatePicker = function(attachment){
            var modalInstance = $uibModal.open({
                templateUrl: 'partials/date_picker.html',
                controller: 'DatePickerModalController',
                windowClass: 'date-picker-modal',
                resolve: {
                    currentDate: function(){
                        return attachment.last_modified;
                    }
                }
            });
            ModalHandler.set(modalInstance);
            modalInstance.result.then(function (date) {
                Attachment.update({id:attachment.id}, {last_modified: date}, function(success){
                    attachment.last_modified = date;
                    $scope.showOfferToInviteGuest();
                });
            }).catch(function () {
                // Logger.log('Modal dismissed');
            });
        };

        $scope.referral.$promise.then(function (data) {
            // Now that we have the referral data, update the uploader's formData with referral_id
            $scope.uploader.formData.push({referral_id: $scope.referral.id});

            $scope.now = function () {
                return Date.now();
            };
        });

        var buildFileName = function (suffix) {
            return $scope.referral.patient.first_name + '-' + $scope.referral.patient.last_name + '-' + suffix + '.pdf';
        };

        $scope.savePdf = function () {
            PDF.createAndSave($scope.referral, buildFileName('referral'), false);
        };

        $scope.savePatientPdf = function () {
            PDF.createAndSave($scope.referral, buildFileName('patient'), true);
        };

        $scope.editPatientDialog = function(){
            var modalInstance = $uibModal.open({
                templateUrl: 'partials/patient_form.html',
                controller: 'EditPatientModalController',
                resolve: {
                    patientForEdit: function(){
                        return $scope.referral.patient;
                    }
                }
            });
            ModalHandler.set(modalInstance);
            modalInstance.result.then(function (patient) {
                $scope.referral.patient = patient;
            }).catch(function () {
                // Logger.log('Modal dismissed');
            });
        };

        $scope.editDestProviderDialog = function(){
            var modalInstance = $uibModal.open({
                templateUrl: 'partials/change_dest_provider_form.html',
                controller: 'ChangeDestProviderModalController',
                size: 'sm',
                resolve: {
                    referral: function(){
                        return $scope.referral;
                    }
                }
            });
            ModalHandler.set(modalInstance);
            modalInstance.result.then(function (providerId) {
                $scope.initModel().then(function() {
                    $scope.showOfferToInviteGuest();
                });  // have to reload referrer object from server, because it needs to provide object that has dest_provider attribute and many other customizations.
            }).catch(function () {
                // Logger.log('Modal dismissed');
            });
        };

        $scope.rejectReferral = function (referral) {
            Referral.updateStatus({id: referral.id}, {status: 'active'},
                function (success) {
                    referral.status = 'active';
                    Notification.success('Status was updated successfully!');
                    $scope.showOfferToInviteGuest();
                },
                function (failure) {
                    Notification.error('Something went wrong while updating referral status...');
                });
        };

        $scope.completeReferral = function (referral) {
            Referral.updateStatus({id: referral.id }, {status: 'completed'},
                function (success) {
                    referral.status = 'completed';
                    Notification.success('Status was updated successfully!');
                    $scope.showOfferToInviteGuest();
                },
                function (failure) {
                    Notification.error('Something went wrong while updating referral status...');
                });
        };

        $scope.deleteAttachment = function(attachment){
            ConfirmDialog.open({
                title: 'Delete this attachment?',
                message: (attachment.attach_file_name || 'This attachment') + ' will be removed from this referral.',
                confirmText: 'Delete attachment'
            }).then(function(confirmed) {
                if (!confirmed) {
                    return;
                }

                function removeFromReferral() {
                    var index = $scope.referral.attachments.indexOf(attachment);
                    if (index === -1) {
                        return;
                    }
                    // Give the bytes back to the running total (DCL-230) — without this
                    // it only ever grows, and eventually rejects uploads the referral
                    // still has room for.
                    $scope.uploader.releaseSize(attachment);
                    $scope.referral.attachments.splice(index, 1);
                    $scope.showOfferToInviteGuest();
                }

                Attachment.delete({id: attachment.id}, removeFromReferral, function (failure) {
                    // A 404 means it's already gone, so the row should go too.
                    if (failure.status === 404) {
                        removeFromReferral();
                        return;
                    }
                    Notification.error((failure.data && failure.data.message) ||
                        'An error occurred while deleting the attachment...');
                });
            });
        };

        $scope.onDropZoneClick = function($event){
            // Only trigger file input if clicking the drop zone itself (UL tag), not child elements
            if ($event.target === $event.currentTarget || $event.target.tagName === 'UL') {
                var fileInput = document.getElementById('view-referral-attachment-file-input');
                if (fileInput) {
                    fileInput.click();
                }
            }
        };

        $scope.showOfferToInviteGuest = function () {
            if(!$scope.referral.no_more_guest_conversion_offers) {
                var modalInstance = $uibModal.open({
                    templateUrl: 'partials/invite_guest_modal.html',
                    controller: 'InviteGuestModalController',
                    resolve: {
                        referral: function(){
                            return $scope.referral;
                        }
                    }
                });
                ModalHandler.set(modalInstance);
            }
        };

        $scope.isArchived = function() {
            var ids = $scope.referral.archived_for_practice_ids;
            return ids && ids.includes($scope.auth.practice_id);
        };

        $scope.isExpired = function() {
            return $scope.referral && $scope.referral.expired_at;
        };

        // DCL-539: the beyond-allowance notice. Present only when the backend
        // serialized the flag (destination-practice viewers of an over-allowance
        // referral), and gone for good once this user dismisses it here.
        $scope.showAllowanceNotice = function() {
            return !!($scope.referral && $scope.referral.beyond_allowance &&
                $scope.referral.allowance && !$scope.allowanceNoticeDismissed);
        };

        $scope.dismissAllowanceNotice = function() {
            // Optimistic: hide immediately, persist in the background. If the save
            // fails the notice simply reappears on the next visit.
            $scope.allowanceNoticeDismissed = true;
            Referral.dismissAllowanceNotice({id: $scope.referral.id}, {}, angular.noop,
                function (failure) {
                    Logger.log('Failed to persist allowance notice dismissal', failure);
                });
        };

        $scope.setArchived = function() {
            Referral.updateArchived({id: $scope.referral.id}, {archived: true},
                function (success) {
                    $scope.referral.archived_for_practice_ids.push($scope.auth.practice_id);
                    Notification.success('Referral archived successfully!');
                },
                function (failure) {
                    Notification.error('Something went wrong setting referral archived status...');
                });
        };

        $scope.removeArchived = function(archived) {
            Referral.updateArchived({id: $scope.referral.id}, {archived: false},
                function (success) {
                    var i = $scope.referral.archived_for_practice_ids.indexOf($scope.auth.practice_id);
                    if (i > -1) $scope.referral.archived_for_practice_ids.splice(i, 1);

                    Notification.success('Referral removed from archive successfully!');
                },
                function (failure) {
                    Notification.error('Something went wrong removing referral from archive...');
                });
        };
    }]);

